import { Link } from "react-router-dom";
import { products } from "./data/products";

export const SiteFooter: React.FC = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="footer-grid">
        <div className="footer-col">
          <h5>Steamtown Media Ltd.</h5>
          <Link to="/home">Home</Link>
          <Link to="/apps">Apps</Link>
          <Link to="/games">Games</Link>
          <Link to="/engineering">Engineering</Link>
          <Link to="/contact">Contact</Link>
        </div>
        <div className="footer-col">
          <h5>Products</h5>
          {/* Driven from the product list: a hardcoded copy here went stale the moment a
              third app shipped, and a missing privacy link is the kind of omission App
              Store review notices. */}
          {products.map((product) => (
            <Link key={product.id} to={product.path}>
              {product.name}
            </Link>
          ))}
        </div>
        <div className="footer-col">
          <h5>Contact</h5>
          <a href="mailto:sales@steamtownmedia.com">sales@steamtownmedia.com</a>
          <a href="mailto:support@steamtownmedia.com">
            support@steamtownmedia.com
          </a>
        </div>
        <div className="footer-col">
          <h5>Legal</h5>
          <Link to="/eula_privacy">EULA &amp; Privacy</Link>
          {products.map((product) => (
            <a key={product.id} href={product.privacyPath}>
              {product.name} privacy
            </a>
          ))}
        </div>
      </div>
      <div className="footer-bottom">
        <span>&copy; {year} Steamtown Media Limited</span>
        <span className="mono">Gilbertsville, Pennsylvania</span>
      </div>
    </footer>
  );
};
